module.exports = __webpack_public_path__ + "static/media/POS.b1e56844.png";